module.exports = __webpack_public_path__ + "static/package-c46f5c5a0ce2065563af8c1a6ab392e7.jpeg";